module.exports = __webpack_public_path__ + "fonts/hue.0614c27197fc3ce572e161840d23b2af.png?";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/images/hue.png
// module id = 907
// module chunks = 5